"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CURRENCY_SYMBOL_MAP = exports.currencySymbolEnum = exports.currencyEnum = void 0;
exports.currencyEnum = ["GBP", "USD"];
exports.currencySymbolEnum = ["£", "$"];
exports.CURRENCY_SYMBOL_MAP = {
  GBP: "£",
  USD: "$"
};